
const VARIANT_STYLES = {
	normal: { bg: "bg-is2-yellow-100", text: "text-is2-yellow-700" },
	White: { bg: "bg-is2-yellow-100", text: "text-is2-yellow-700" },
	"Primary Blue": { bg: "bg-is2-blue", text: "text-white" },
	"Light Yellow": { bg: "bg-white", text: "text-is2-blue" },
	"Transparent": { bg: "bg-transparent", text: "text-white" },
};
const DEFAULT_STYLES = { bg: "bg-white", text: "text-is2-yellow-700" };

export const ListTile = ({ tiles, variant, isVertical, columnCount, iconSize, iconTextGap }) => {
	const { bg: bgColor, text: textColor } = VARIANT_STYLES[variant] || DEFAULT_STYLES;
	const gridCols = isVertical ? "" : columnCount
		? `md:grid-cols-${columnCount}`
		: { 4: "md:grid-cols-2" }[tiles.length] || "md:grid-cols-3";

	return (
		<div className="flex flex-col mt-4 w-full">
			<div className={`grid grid-cols-1 ${gridCols} gap-4 mt-2 p-6 px-10 rounded-[32px] ${bgColor} w-full`}>
				{tiles.map(({ imageUrl, title }, index) => (
					<div key={index} className={`flex ${iconTextGap ? `gap-${iconTextGap}` : "gap-6"} items-center justify-start py-2`}>
						<img src={imageUrl} alt={title} loading="lazy" className="shrink-0" style={{ width: iconSize ?? "35px", height: iconSize ?? "35px" }} />
						<h5 className={`${textColor} m-0 text-left`}>{title}</h5>
					</div>
				))}
			</div>
		</div>
	);
};

export const ListTileEmbedded = ({ tiles, variant }) => {
	const { bg: bgColor, text: textColor } = VARIANT_STYLES[variant] || DEFAULT_STYLES;

	return (
		<div className={`grid grid-cols-1 gap-2 ${bgColor} w-full`}>
			{tiles.map(({ imageUrl, title }, index) => (
				<div key={index} className="flex gap-4 items-center justify-start">
					<img src={imageUrl} alt={title} loading="lazy" className="w-4 h-4" />
					<p className={`${textColor} m-0 text-left`}>{title}</p>
				</div>
			))}
		</div>
	);
};
